import { createAction, createSlice } from "@reduxjs/toolkit";

const markLessonCompletedSlice = createSlice({
  name: "markLessonCompleted",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = markLessonCompletedSlice;
const markLessonCompletedAction = createAction(name);

export {
  markLessonCompletedAction,
  actions as markLessonCompletedActions,
  reducer as markLessonCompletedReducer,
};
